import React from 'react';
import { Descriptions } from 'antd';
import { PropertyIdentifier } from 'common/models';

const PropertyIdentifierDescriptions: React.FC<{
  propertyIdentifier: PropertyIdentifier;
  accountNumber?: string;
}> = (props: {
  propertyIdentifier: PropertyIdentifier;
  accountNumber?: string;
}) => {
  const { propertyIdentifier, accountNumber } = props;
  const {
    section,
    subSection,
    block,
    lot,
    subLot,
    printKey,
    suffix,
    district,
    subBlock,
    unitNumber,
    buildingNumber,
    volume,
    filedMapInformation,
  } = propertyIdentifier;

  return (
    <Descriptions
      title="Property Identifier"
      bordered
      size={'small'}
      column={3}
    >
      <Descriptions.Item label="District" span={1}>
        {district}
      </Descriptions.Item>
      <Descriptions.Item label="Section" span={1}>
        {section}
      </Descriptions.Item>
      <Descriptions.Item label="Sub Section">{subSection}</Descriptions.Item>
      <Descriptions.Item label="Block" span={1}>
        {block}
      </Descriptions.Item>
      <Descriptions.Item label="SubBlock" span={1}>
        {subBlock}
      </Descriptions.Item>
      <Descriptions.Item label="Print Key">{printKey}</Descriptions.Item>
      <Descriptions.Item label="Lot">{lot}</Descriptions.Item>
      <Descriptions.Item label="Sub Lot">{subLot}</Descriptions.Item>
      <Descriptions.Item label="Suffix">{suffix}</Descriptions.Item>
      <Descriptions.Item label="Building No.">
        {buildingNumber}
      </Descriptions.Item>
      <Descriptions.Item label="Unit No.">{unitNumber}</Descriptions.Item>
      <Descriptions.Item label="Volume">{volume}</Descriptions.Item>
      <Descriptions.Item label="Filed Map Information" span={3}>
        {filedMapInformation}
      </Descriptions.Item>
      {accountNumber && (
        <Descriptions.Item label="Account Number" span={3}>
          {accountNumber}
        </Descriptions.Item>
      )}
    </Descriptions>
  );
};

export default PropertyIdentifierDescriptions;
